"use strict";

var _toConsumableArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var idlUtils = require("../generated/utils.js");

exports.implementation =
/*#__PURE__*/
function () {
  function NodeListImpl(args, privateData) {
    _classCallCheck(this, NodeListImpl);

    if (privateData.nodes) {
      this._list = _toConsumableArray(privateData.nodes);
      this._isLive = false;
    } else {
      this._list = [];
      this._isLive = true;
      this._version = -1;
      this._element = privateData.element;
      this._query = privateData.query;

      this._update();
    }
  }

  _createClass(NodeListImpl, [{
    key: "item",
    value: function item(index) {
      this._update();

      return this._list[index] || null;
    }
  }, {
    key: "_update",
    value: function _update() {
      if (this._isLive) {
        if (this._version < this._element._version) {
          var snapshot = this._query();

          for (var i = 0; i < snapshot.length; i++) {
            this._list[i] = snapshot[i];
          }

          this._list.length = snapshot.length;
          this._version = this._element._version;
        }
      }
    }
  }, {
    key: "length",
    get: function get() {
      this._update();

      return this._list.length;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      this._update();

      return this._list.keys();
    }
  }]);

  return NodeListImpl;
}();